export const SET_EMAIL_PHONE = "SET_EMAIL_PHONE";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_OTP = "SET_OTP";
export const CLEAR_PROCESS = "CLEAR_PROCESS";
